import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import { useCreatePersonaInquiryMutation } from '@/store/api/Persona/Persona.query'
import { useUserInfoQuery } from '@/store/api/Users/Users.query'
import { trackKYCStepViewed, KYCSteps } from '@/utils/analytics'

export const KYCVerification = () => {
  const { t } = useTranslation()
  const hasTrackedView = useRef(false)
  const { data: userData, isLoading } = useUserInfoQuery()

  // Track KYC step viewed once on mount
  useEffect(() => {
    if (!hasTrackedView.current) {
      trackKYCStepViewed(KYCSteps.VERIFICATION_START)
      hasTrackedView.current = true
    }
  }, [])

  const [
    createPersonaInquiry,
    {
      isLoading: isLoadingCreatePersonaInquiry,
      isError: isErrorCreatePersonaInquiry,
    },
  ] = useCreatePersonaInquiryMutation()

  const handleVerifyIdentity = async () => {
    if (!userData?.id || !userData?.email) {
      toast.error(t('kyc.verification.errorUserInfo'))
      return
    }

    try {
      const response = await createPersonaInquiry({
        referenceId: userData.id,
        language: userData.language,
      }).unwrap()
      window.location.href = response.hostedFlowUrl
    } catch (error) {
      toast.error(t('kyc.verification.errorStarting'))
    }
  }

  return (
    <WeScreen
      useHeader={false}
      isError={isErrorCreatePersonaInquiry}
      isLoading={isLoading}
      customViewStyles="max-md:p-0"
    >
      <div className="flex flex-col gap-8 items-center justify-center w-full h-full">
        <div className="flex flex-col gap-3 justify-center w-1/2 text-center max-md:w-full">
          <p className="text-neutralColor text-[40px] max-md:text-3xl">
            {t('kyc.verification.title')}
          </p>
          <p className="text-neutralColor80 text-2xl max-md:text-xl">
            {t('kyc.verification.subtitle')}
          </p>
        </div>
        <Button
          className="w-1/8 text-bold text-base text-staticWhite"
          isLoading={isLoadingCreatePersonaInquiry}
          onClick={handleVerifyIdentity}
        >
          {t('kyc.verification.startButton')}
        </Button>
      </div>
    </WeScreen>
  )
}
